<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartoptions: {
      type: Object,
      default: null
    }
  },
  async mounted() {
    this.axios.get("https://beacon.izoox.com/chart").then(response => {
      this.renderChart(response.data, this.chartoptions);
      this.$emit("rendered", true);
    });
  }
};
</script>
